import { render, staticRenderFns } from "./client-reservation-card.vue?vue&type=template&id=52e1715e&scoped=true&"
import script from "./client-reservation-card.vue?vue&type=script&lang=js&"
export * from "./client-reservation-card.vue?vue&type=script&lang=js&"
import style0 from "./client-reservation-card.vue?vue&type=style&index=0&id=52e1715e&lang=scss&scoped=true&"
import style1 from "./client-reservation-card.vue?vue&type=style&index=1&id=52e1715e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e1715e",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QAvatar,QSkeleton,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QAvatar,QSkeleton,QImg})
